//@ts-nocheck
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';
import Datepicker from "react-tailwindcss-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { CalendarIcon, CheckIcon, ClockIcon } from 'lucide-react';
import { TimePicker } from 'rsuite';
// import 'rsuite/dist/rsuite.min.css';
import { Listbox, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import { ChevronDownIcon, CrossIcon } from '../../icons/Icons';
import timezonesData from '../../../utils/timezones.json';
import "../../../styles/resuit.css"
import { createAppReview, fetchAppReviewList, updateAppReviewData } from '../../../features/AppReview/AppReviewSlice';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from '../../../app/hooks';
import { toast } from 'sonner';
import { fetchReviewListByJobId } from '../../../features/review/reviewSlice';
import { fetchJobPipelineDetailsData } from '../../../features/hiringpipeline/hiringPipelineSlice';




function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

export default function UpdateAppReview({ opneMeeting, setOpenMeeting, applicationDetails, meetingList, selectedMeeting, setMeetingList, job: jobProp, app: appProp, quickData,onSuccess }: any) {
  // const { baseId, jobId, applicationId } = useParams<{ baseId: string; jobId: string; applicationId: string; }>();
  const { baseId, jobId: jobIdFromParams, applicationId: applicationIdFromParams } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();

  const jobId = jobProp || jobIdFromParams;
  const applicationId = appProp || applicationIdFromParams || quickData


  const dispatch = useAppDispatch();
  const [jobTeamMembers, setJobTeamMembers] = useState([]);
  const userDetailsData = localStorage.getItem('jobByHiringTeamMembers');
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [isLoading, setIsLoading] = useState(false);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [organisedData, setOrganisedData] = useState(null)
  const jobPipelineStageData = JSON.parse(localStorage.getItem("jobPipelineStageData") || "{}");
  const [selectedPipelineStage, setSelectedPipelineStage] = useState(null);
  const [reviewTemplates, setReviewTemplates] = useState([]);



  // Fetch job team members from local storage on component mount
  // useEffect(() => {
  //   const storedJobTeamMembers = JSON.parse(localStorage.getItem("jobByHiringTeamMembers") || "[]");
  //   setJobTeamMembers(storedJobTeamMembers);
  // }, []);

  useEffect(() => {
    if (baseId) {
      const fetchTeams = async () => {
        const storedBase = localStorage.getItem('jobByHiringTeamMembers');
        if (storedBase) {
          let data = JSON.parse(storedBase)
          setJobTeamMembers(data)
        } else {
          try {
            const baseResponse = await dispatch(
              fetchJobPipelineDetailsData({
                baseId: Number(baseId),
                JobId: jobId
              })
            );
            setJobTeamMembers(baseResponse.payload.data.teamMembers);
          } catch (error) {
            console.error("Error fetching base member details:", error);
          }
        }
      };
      fetchTeams();
    }
  }, [baseId, dispatch]);


  useEffect(() => {
    const fetchReviewTemplates = async () => {
      try {
        const response = await dispatch(
          fetchReviewListByJobId({
            baseId: Number(baseId),
            jobId: jobId
          })
        );

        if (response.payload) {
          setReviewTemplates(response.payload.data);
        }
      } catch (error) {
        toast.error('Failed to fetch review templates');
      }
    };

    if (baseId && jobId) {
      fetchReviewTemplates();
    }
  }, [baseId, jobId, dispatch]);

  useEffect(() => {
    if (selectedMeeting && reviewTemplates && reviewTemplates.length > 0) {

      const organiser = baseMembers.find(member => member.user_id === selectedMeeting.review_by);
      if (organiser) {
        setOrganisedData(organiser);
      }


      const pipelineStage = jobPipelineStageData.stages.find((stage: any) => stage.id === selectedMeeting.stage_id);
      setSelectedPipelineStage(pipelineStage);

      // Only process review templates if we have the data
      if (selectedMeeting.review_template_id) {
        const selectedTemplates = selectedMeeting.review_template_id.split(',').map((id: any) => {
          return reviewTemplates.find((template: any) => template.id === id);
        }).filter((template: any) => template);

        setSelectedParticipants(selectedTemplates);
      }
    }
  }, [selectedMeeting]);


  // Find participants from baseMembers using user_ids from jobTeamMembers
  const availableParticipants = useMemo(() => {
    return jobTeamMembers.map(teamMember => {
      const baseMember = baseMembers.find(member => member.user_id === teamMember.user_id);

      return {
        id: teamMember.user_id,
        name: teamMember.name,

      };
    }).filter(participant => participant.name);
  }, [jobTeamMembers, baseMembers]);


  // Get available pipeline stages
  const availablePipelineStages = useMemo(() => {
    return jobPipelineStageData.stages || [];
  }, [jobPipelineStageData]);


  // Handle Save function
  const handleSave = async () => {
    // Validate required fields
    if (!organisedData) {
      toast.error('Please select a review by person');
      return;
    }

    // if (!selectedPipelineStage) {
    //   toast.error('Please select a pipeline stage');
    //   return;
    // }

    // if (selectedParticipants.length === 0) {
    //   toast.error('Please select at least one review template');
    //   return;
    // }

    try {
      setIsLoading(true);

      // Prepare payload
      const payload = {
        app_id: applicationId,
        baseId: baseId,
        job_id: jobId,
        review_by: organisedData?.user_id,
        stage_id: selectedPipelineStage?.id,
        review_template_id: selectedParticipants?.map(participant => participant?.id)?.toString(),
        // comment: 'test',
        // app_scorecard_id: 3
      };

      // Dispatch create app review action
      const response = await dispatch(updateAppReviewData({
        baseId: Number(baseId),
        id: selectedMeeting.id,
        payload,
      })).unwrap();



      // if(response.sta?)
      if (response.status === 200) {
        toast.success('Review update successfully');
        setSelectedParticipants([]);
        setOrganisedData(null);
        setSelectedPipelineStage(null);


        const res = await dispatch(fetchAppReviewList({ baseId: parseInt(baseId), appId: applicationId })) // Pass an object with baseId and appId
          .unwrap()

        // Update meeting list if needed
        if (res) {
          setMeetingList(res.data);
          if (onSuccess) {
           onSuccess(organisedData?.user_id,selectedMeeting.id);
          }
        }
      }


      // Close the dialog
      setOpenMeeting(false);
    } catch (error) {
      // Handle error
      toast.error(error?.message || 'Failed to update review');
    } finally {
      setIsLoading(false);
    }
  };



  return (
    <Dialog open={opneMeeting} onClose={() => setOpenMeeting(false)} className="relative z-10">
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4
             data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-[35rem] data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 rounded-t-md">
              <div className="sm:flex sm:items-start">
                <div className=" w-full">
                  <DialogTitle as="h3" className="text-base font-semibold text-gray-900">
                    Update Review
                  </DialogTitle>
                  <div className="absolute right-[7px] top-[7px] hidden pr-4 pt-4 sm:block">
                    <button
                      type="button"
                      onClick={() => setOpenMeeting(false)}
                      className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                    >
                      <span className="sr-only">Close</span>
                      <CrossIcon />
                    </button>
                  </div>
                  <div className="mt-4">
                    <div className='bg-[#e0e0e0] w-full h-[1px] mb-0' />
                    <form className="space-y-4 mt-5">

                      <div className="grid grid-cols-1 gap-4">
                        <div>
                          <label htmlFor="participants" className="block text-sm font-medium text-gray-700">
                            Review Template
                          </label>
                          <div className="relative mt-1.5">
                            <Listbox value={selectedParticipants} onChange={setSelectedParticipants} multiple>
                              {({ open }) => (
                                <>
                                  <div className="relative">
                                    <Listbox.Button
                                      className="w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
                                text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
                                focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 
                                border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-[38px] px-3 py-2"
                                    >
                                      <span className="block truncate font-normal">
                                        {selectedParticipants.length === 0
                                          ? "Select review template"
                                          : `${selectedParticipants.length} template(s) selected`}
                                      </span>
                                      <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                                        <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                                      </span>
                                    </Listbox.Button>

                                    <Transition
                                      show={open}
                                      as={Fragment}
                                      leave="transition ease-in duration-100"
                                      leaveFrom="opacity-100"
                                      leaveTo="opacity-0"
                                    >
                                      <Listbox.Options className="overflow-auto max-h-[120px] absolute z-10 mt-[9px] left-[-2px] bg-white w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                        {reviewTemplates.length > 0 ? (
                                          reviewTemplates.map((participant) => (
                                            <Listbox.Option
                                              key={participant.id}

                                              className={({ active }) =>
                                                classNames(
                                                  active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                                  'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                                )
                                              }
                                              value={participant}
                                            >
                                              {({ selected, active }) => (
                                                <>
                                                  <div className="flex items-center">
                                                    <span className={`block capitalize truncate ${selected ? 'font-medium' : 'font-normal'}`}>
                                                      {participant.review_name}
                                                    </span>
                                                  </div>

                                                  {selected ? (
                                                    <span
                                                      className={`absolute inset-y-0 right-0 flex items-center pr-4 ${active ? 'text-white' : 'text-indigo-600'
                                                        }`}
                                                    >
                                                      <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                  ) : null}
                                                </>
                                              )}
                                            </Listbox.Option>
                                          ))
                                        ) : (
                                          <div className="px-3 py-2 text-sm text-gray-500">No review template available</div>
                                        )}
                                      </Listbox.Options>
                                    </Transition>
                                  </div>
                                </>
                              )}
                            </Listbox>
                          </div>

                        </div>
                        <div>
                          <label htmlFor="organisedBy" className="block text-sm font-medium text-gray-700">
                            Review By
                          </label>
                          <Listbox value={organisedData} onChange={setOrganisedData}>
                            <div className="relative mt-1.5">
                              {/* Listbox Button */}
                              <Listbox.Button className="w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
        text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
        focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 
        border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-[38px] px-3 py-2">
                                <span className="block truncate font-normal">
                                  {organisedData ? organisedData.name : "Review by"}
                                </span>
                                <span className="pointer-events-none">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-4 h-4 text-gray-500"
                                  >
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M6 9l6 6l6 -6" />
                                  </svg>
                                </span>
                              </Listbox.Button>

                              {/* Listbox Options */}
                              <Transition
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <Listbox.Options className="overflow-auto h-[180px] absolute z-10 mt-[9px] left-[-2px] bg-white w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                  {baseMembers.map((member) => (
                                    <Listbox.Option
                                      key={member.id}
                                      value={member}
                                      className={({ active }) =>
                                        classNames(
                                          active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                          'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                        )
                                      }
                                    >
                                      {({ selected }) => (
                                        <>
                                          <span
                                            className={`block truncate capitalize ${selected ? 'font-medium' : 'font-normal'}`}
                                          >
                                            {member.name}
                                          </span>
                                          {selected && (
                                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={24}
                                                height={24}
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="currentColor"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="w-4 h-4"
                                              >
                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                <path d="M5 12l5 5l10 -10" />
                                              </svg>
                                            </span>
                                          )}
                                        </>
                                      )}
                                    </Listbox.Option>
                                  ))}
                                </Listbox.Options>
                              </Transition>
                            </div>
                          </Listbox>
                        </div>

                        <div>
                          <label htmlFor="pipelineStage" className="block text-sm font-medium text-gray-700">
                            Pipeline Stage
                          </label>
                          <Listbox value={selectedPipelineStage} onChange={setSelectedPipelineStage}>
                            <div className="relative mt-1.5">
                              <Listbox.Button className="w-[100%] inline-flex items-center justify-between whitespace-nowrap rounded-md 
                                text-sm font-medium transition-colors outline-offset-2 focus-visible:outline focus-visible:outline-2
                                focus-visible:outline-ring/70 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 
                                border border-input bg-background shadow-sm shadow-black/5 hover:bg-accent hover:text-accent-foreground h-[38px] px-3 py-2">
                                <span className="block truncate font-normal">
                                  {selectedPipelineStage ? selectedPipelineStage.stage_name : "Select Pipeline Stage"}
                                </span>
                                <span className="pointer-events-none">
                                  <ChevronDownIcon className="w-4 h-4 text-gray-500" />
                                </span>
                              </Listbox.Button>

                              <Transition
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                              >
                                <Listbox.Options className="overflow-auto h-[180px] absolute z-10 mt-[9px] left-[-2px] bg-white w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2">
                                  {availablePipelineStages.length > 0 ? (
                                    availablePipelineStages.map((stage) => (
                                      <Listbox.Option
                                        key={stage.id}
                                        value={stage}
                                        className={({ active }) =>
                                          classNames(
                                            active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                            'relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0'
                                          )
                                        }
                                      >
                                        {({ selected }) => (
                                          <>
                                            <span
                                              className={`block truncate ${selected ? 'font-medium' : 'font-normal'}`}
                                            >
                                              {stage.stage_name || 'Unnamed Stage'}
                                            </span>
                                            {selected && (
                                              <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-indigo-600">
                                                <CheckIcon className="w-4 h-4" aria-hidden="true" />
                                              </span>
                                            )}
                                          </>
                                        )}
                                      </Listbox.Option>
                                    ))
                                  ) : (
                                    <div className="px-3 py-2 text-sm text-gray-500">No pipeline stages available</div>
                                  )}
                                </Listbox.Options>
                              </Transition>
                            </div>
                          </Listbox>
                        </div>
                      </div>



                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-white px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 rounded-b-md">
              <button
                type="button"
                onClick={handleSave}
                className="inline-flex w-full justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 sm:ml-3 sm:w-auto"
              >
                {isLoading ? (
                  <div className='flex items-center gap-[6px]'>
                    Update Review
                    <div className="simple-spinner">
                      <span></span>
                    </div>
                  </div>
                ) : (
                  '  Update Review'
                )}

              </button>
              <button
                type="button"
                data-autofocus
                onClick={() => setOpenMeeting(false)}
                className="mt-3 inline-flex w-full justify-center rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
              >
                Cancel
              </button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}